import React, { useState } from "react";
import { useAuth } from "../lib/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import Hummingbird from "../components/brand/Hummingbird";

const AdminLogin = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, pw);
      const adminRoles = new Set(["admin", "SUPER_ADMIN", "ACADEMY_ADMIN", "CONTENT_EDITOR",
                                  "MENTOR_REVIEWER", "FINANCE_MANAGER", "SUPPORT_AGENT", "FACILITATOR"]);
      if (adminRoles.has(u.role)) nav("/admin");
      else nav("/academy/dashboard");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Login fehlgeschlagen");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-24 pb-12" data-testid="admin-login-page">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="inline-flex"><Hummingbird size={56} /></div>
          <div className="overline mt-4">SAT · Admin</div>
          <h1 className="headline-xl text-4xl mt-2">Anmelden</h1>
        </div>
        <form onSubmit={submit} className="glass rounded-2xl p-8 space-y-4" data-testid="admin-login-form">
          <input type="email" required className="sat-input" placeholder="E-Mail" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" />
          <input type="password" required className="sat-input" placeholder="Passwort" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="admin-login-password" />
          <button disabled={loading} className="btn-primary w-full justify-center" data-testid="admin-login-submit">
            {loading ? <Loader2 className="animate-spin" size={18} /> : (<><Lock size={16} /> Anmelden</>)}
          </button>
          {err && <p className="text-red-300 text-sm">{err}</p>}
          <div className="text-center text-xs text-white/45 pt-2">
            <Link to="/" className="hover:text-white">← Zurück zur Website</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
